import React from "react";
import { KRUMAGO } from "../s3-assets/Krumago";

function About() {
  const excludedPrefixes = ["www", "dev", "uat"];
  const hostnameParts = window.location.hostname.split(".");
  const hasDomain =
    hostnameParts.length > 1 && !excludedPrefixes.includes(hostnameParts[0]);

  const sections = [
    {
      id: 1,
      title: "Cutting-Edge Curriculum",
      description:
        "Immerse your child in an advanced curriculum designed to foster innovation and adaptability in a rapidly changing world.",
      imgSrc: KRUMAGO.IMAGES.CURRICULUM,
    },
    {
      id: 2,
      title: "Expert Faculty",
      description:
        "Learn from a team of passionate, experienced educators dedicated to nurturing individual student potential.",
      imgSrc: KRUMAGO.IMAGES.PERSONAL_TRAINER,
    },
    {
      id: 3,
      title: "Small Class Sizes",
      description:
        "Enjoy personalized learning experiences in small class settings that prioritize student engagement and interaction.",
      imgSrc: KRUMAGO.IMAGES.CLASSROOM,
    },
    {
      id: 4,
      title: "State-of-the-Art Facilities",
      description:
        "Discover our cutting-edge learning environments, featuring top-tier technology and resources for modern education.",
      imgSrc: KRUMAGO.IMAGES.BUILDING,
    },
    {
      id: 5,
      title: "Inclusive and Diverse Community",
      description:
        "Be part of a community that values and celebrates diversity, creating a safe and inclusive space for all students.",
      imgSrc: KRUMAGO.IMAGES.INCLUSIVITY,
    },
    {
      id: 6,
      title: "Parental Involvement",
      description:
        "Partner with us in your child’s education, fostering a collaborative relationship that strengthens their academic journey.",
      imgSrc: KRUMAGO.IMAGES.GUIDANCE,
    },
    {
      id: 7,
      title: "Strong Values-Based Education",
      description:
        "Shape character and leadership through our commitment to teaching strong ethical values and social responsibility.",
      imgSrc: KRUMAGO.IMAGES.E_LEARNING_ALT,
    },
  ];

  const SectionCard = ({ title, description, imgSrc, cardId }) => (
    <div
      className="bg-white p-4 rounded-lg shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl w-full max-w-xs text-center"
      id={cardId}
    >
      <div className="flex justify-center items-center h-24 mb-4">
        <img
          loading="lazy"
          src={imgSrc}
          alt={title}
          className="max-w-full max-h-full"
          id={`${cardId}-image`}
        />
      </div>

      <h3
        className="text-lg font-semibold text-teal-600 mb-2"
        id={`${cardId}-title`}
      >
        {title}
      </h3>

      <p className="text-sm text-gray-600" id={`${cardId}-desc`}>
        {description}
      </p>
    </div>
  );

  const AboutSection = () => (
    <div
      className="bg-gradient-to-br from-gray-200 to-gray-100 py-16 px-8 text-gray-800 text-center relative overflow-hidden"
      id="about-section"
    >
      <div className="absolute inset-0 bg-white opacity-60 z-10"></div>

      <div className="relative z-20">
        <h2
          className="text-4xl font-bold text-purple-700 font-poppins mb-6 text-left"
          id="about-title"
        >
          Why Choose the AVPS Academy?
        </h2>

        <div
          className="flex flex-wrap justify-center gap-6"
          id="about-cards-wrapper"
        >
          {sections.map((section) => (
            <SectionCard
              key={section.id}
              title={section.title}
              description={section.description}
              imgSrc={section.imgSrc}
              cardId={`about-card-${section.id}`}
            />
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div id="about-page" className="pt-24">
      <div className="tech-bar" id="tech-section">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-8">
          <div className="tech-inner-image flex-1 max-w-xs">
            <img
              loading="lazy"
              src={KRUMAGO.IMAGES.E_LEARNING}
              alt="Welcome"
              className="w-full h-auto"
              id="hero-image"
            />
          </div>

          <div className="tech-inner-text flex-2 max-w-lg">
            <h1
              className="text-2xl md:text-3xl font-bold text-purple-700 mb-4"
              id="hero-title"
            >
              AVPS Academy
            </h1>

            <p
              className="acad-subtitle-about text-lg md:text-xl text-gray-700 leading-relaxed"
              id="hero-subtitle"
            >
              {hasDomain ? (
                <>
                  At the AVPS Academy, we are committed to providing
                  unparalleled educational experiences for our students. Our
                  esteemed faculty members are experts in their respective
                  fields and are dedicated to helping students achieve their
                  academic and personal goals. With state-of-the-art facilities
                  and a comprehensive curriculum, we offer a dynamic learning
                  environment that nurtures intellectual curiosity, critical
                  thinking skills, and personal growth.
                </>
              ) : (
                <>
                  In the fast-paced world of business, staying ahead requires
                  efficiency and precision. Take a moment to reflect on your
                  current processes—are you still managing crucial aspects of
                  your operations manually? From overseeing your products or
                  services to handling customer schedules and student
                  follow-ups, embracing modern solutions can make a significant
                  difference in your productivity and overall success.
                </>
              )}
            </p>
          </div>
        </div>
      </div>

      {hasDomain && <AboutSection />}

      {hasDomain && (
        <div
          className="relative inline-block max-w-full"
          id="about-signup-banner"
        >
          <img
            loading="lazy"
            src={KRUMAGO.IMAGES.JOIN_US_ABOUT}
            alt="Welcome"
            className="w-full h-auto"
            id="signup-image"
          />

          <a
            href="/sign-in"
            className="absolute top-64 left-1/2 transform -translate-x-1/2 bg-purple-700 text-white px-6 py-3 rounded-lg text-lg font-semibold no-underline inline-block z-10 whitespace-nowrap"
            id="signup-button"
          >
            Sign Up
          </a>
        </div>
      )}
    </div>
  );
}

export default About;
